<template>
    <div class="recharge-page">
        <!-- 头部用户信息 -->
        <div class="header">
            <div class="user-info">
                <img :src="topUpInfo.userAvatar || 'http://49.232.163.2:5159/image/30.png'" alt="用户头像" class="avatar">
                <div class="user-meta">
                    <div class="user-name">{{ this.topUpInfo.userName }}</div>
                    <div class="user-id">账号ID: {{ this.topUpInfo.userID }}</div>
                </div>
            </div>
            <div class="balance">
                <span class="balance-label">账户云币</span>
                <span class="balance-amount">{{ this.topUpInfo.remainingSum }}</span>
                <!-- 新增云币换算说明 -->
                <div class="currency-tip">1元 = 10云币</div>
            </div>
        </div>

        <!-- 充值金额选择（核心区域） -->
        <div class="recharge-section">
            <h3 class="section-title">选择充值金额</h3>

            <!-- 新增金额换算提示 -->
            <div class="amount-tip">
                <i class="icon-info"></i>
                充值¥{{ selectedAmount }}可获得 {{ selectedAmount * 10 }} 云币（1元 = 10云币）
            </div>

            <!-- 固定金额选项 -->
            <div class="amount-selector">
                <button class="amount-btn" :class="{ active: selectedAmount === 50 }" @click="selectAmount(50)">
                    ¥50 <small>（500云币）</small>
                </button>
                <button class="amount-btn" :class="{ active: selectedAmount === 100 }" @click="selectAmount(100)">
                    ¥100 <small>（1000云币）</small>
                </button>
                <button class="amount-btn" :class="{ active: selectedAmount === 300 }" @click="selectAmount(300)">
                    ¥300 <small>（3000云币）</small>
                </button>
                <button class="amount-btn" :class="{ active: selectedAmount === 500 }" @click="selectAmount(500)">
                    ¥500 <small>（5000云币）</small>
                </button>
            </div>

            <!-- 大客户折扣按钮 -->
            <div class="vip-section">
                <button class="vip-btn">获取大客户折扣（暂未开放）</button>
            </div>

            <!-- 充值确认按钮（调小尺寸） -->
            <div class="confirm-section">
                <button class="confirm-recharge-btn" @click="goPay()">确认充值 ¥{{ selectedAmount }}</button>
            </div>
        </div>

        <!-- 注意事项 -->
        <div class="notice">
            <h4 class="notice-title">充值须知</h4>
            <ul class="notice-list">
                <li>充值的金额不能提现，亦不能在不同的账号之间转移，仅允许在智步云上模型网进行消费使用。</li>
                <li>请务必根据您的自身消费能力和实际需求，合理充值、购买，警惕代充、返利等诱导行为，勿向陌生人付款。</li>
                <li>充值换算规则：1元 = 10云币，充值金额将按此比例自动兑换为对应数量的云币。</li>
                <li>充值则视为自动同意
                    <a style="color: #ffb042;cursor: pointer;text-decoration: none;"
                        @click="openRechaegeAgreement">支付协议</a>。
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RechargePage',
    data() {
        return {
            selectedAmount: 50, // 默认选中50元
            topUpInfo: []
        };
    },
    mounted() {
        this.TopUpCenter();
    },
    methods: {
        openRechaegeAgreement() {
            window.open('/#/protocol/recharge-doc', '_blank');
        },
        goPay() {
            this.$apiFun.getPayment({
                Payment: this.selectedAmount,//（类型为1时：模型ID可为空）
                // Payment: 0.01,//（类型为1时：模型ID可为空）
            }).then(res => {
                if (res.status === 200) {
                    window.open(res.obj, '_blank')
                } else {
                    this.$message.error(res.msg || '跳转支付页失败');
                }
            }).catch(err => {
                this.$message.error('跳转支付页调用失败');
            });
        },
        // 选择固定金额
        selectAmount(amount) {
            this.selectedAmount = amount;
        },
        TopUpCenter() {
            this.$apiFun.getTopUpCenter()
                .then(res => {
                    if (res.status === 200) {
                        this.topUpInfo = res.obj;
                    }
                })
                .catch(err => {
                    console.error('充值中心信息加载失败:', err);
                    this.$message?.error('充值中心信息加载失败，请稍后重试');
                });
        }
    }
};
</script>

<style lang="less" scoped>
// 主题变量优化（增强空间感）
@bg-primary: #121418; // 主背景色（更深更通透）
@bg-secondary: #1a1d24; // 次要背景色
@bg-tertiary: #232730; // 三级背景色（金额按钮）
@text-primary: #f5f5f5; // 主文本色
@text-secondary: #949ba4; // 次要文本色
@accent: #168cff; // 主强调色（蓝色更清爽）
@accent-light: rgba(22, 140, 255, 0.1); // 强调色浅背景
@border-color: #2d313a; // 边框色
@shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.15); // 轻微阴影
@shadow-md: 0 4px 12px rgba(0, 0, 0, 0.2); // 中等阴影
@radius-sm: 6px; // 小圆角
@radius-md: 8px; // 中等圆角
@radius-lg: 12px; // 大圆角
@spacing-xs: 8px;
@spacing-sm: 12px;
@spacing-md: 20px;
@spacing-lg: 30px;

.recharge-page {
    background-color: @bg-primary;
    color: @text-primary;
    min-height: 100vh;
    padding: @spacing-md @spacing-lg;
    box-sizing: border-box;
    font-family: 'Inter', system-ui, sans-serif;

    // 头部用户信息（增强空间感）
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: @spacing-md;
        background-color: @bg-secondary;
        border-radius: @radius-lg;
        box-shadow: @shadow-sm;
        margin-bottom: @spacing-lg;

        .user-info {
            display: flex;
            align-items: center;
            gap: @spacing-md;

            .avatar {
                width: 60px;
                height: 60px;
                border-radius: 10%;
                border: 2px solid @border-color;
                background-color: @bg-tertiary;
                object-fit: cover;
            }

            .user-meta {
                .user-name {
                    font-size: 18px;
                    font-weight: 600;
                    margin-bottom: @spacing-xs;
                }

                .user-id {
                    font-size: 13px;
                    color: @text-secondary;
                }
            }
        }

        .balance {
            text-align: right;

            .balance-label {
                display: block;
                font-size: 13px;
                color: @text-secondary;
                margin-bottom: @spacing-xs;
            }

            .balance-amount {
                font-size: 24px;
                font-weight: 600;
                color: @accent;
                display: block;
            }

            // 新增云币换算提示
            .currency-tip {
                font-size: 12px;
                color: @text-secondary;
                margin-top: @spacing-xs;
                background-color: rgba(22, 140, 255, 0.1);
                padding: 2px 8px;
                border-radius: 4px;
                display: inline-block;
            }
        }
    }

    // 充值金额选择区域（核心优化）
    .recharge-section {
        background-color: @bg-secondary;
        border-radius: @radius-lg;
        padding: @spacing-lg;
        box-shadow: @shadow-sm;
        margin-bottom: @spacing-lg;

        .section-title {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: @spacing-sm;
            color: @text-primary;
            padding-bottom: @spacing-sm;
            border-bottom: 1px solid @border-color;
        }

        // 新增金额换算提示
        .amount-tip {
            font-size: 14px;
            color: @text-secondary;
            margin-bottom: @spacing-md;
            padding: @spacing-xs @spacing-sm;
            background-color: @bg-tertiary;
            border-radius: @radius-sm;
            display: flex;
            align-items: center;

            .icon-info {
                width: 16px;
                height: 16px;
                background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23949ba4"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/></svg>') no-repeat center;
                margin-right: @spacing-xs;
            }
        }

        // 金额选择按钮（增强空间感和交互）
        .amount-selector {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
            gap: @spacing-md;
            margin-bottom: @spacing-lg;

            .amount-btn {
                background-color: @bg-tertiary;
                border: 2px solid @border-color;
                color: @text-primary;
                padding: @spacing-lg;
                border-radius: @radius-md;
                cursor: pointer;
                font-size: 18px;
                font-weight: 500;
                transition: all 0.3s ease;
                position: relative;
                overflow: hidden;

                small {
                    font-size: 12px;
                    color: @text-secondary;
                    font-weight: normal;
                    display: block;
                    margin-top: 4px;
                }

                // 选中状态
                &.active {
                    border-color: @accent;
                    color: @accent;
                    background-color: @accent-light;
                    box-shadow: 0 0 0 2px rgba(22, 140, 255, 0.2);

                    small {
                        color: @accent;
                    }
                }

                // 悬停效果
                &:hover {
                    border-color: lighten(@border-color, 10%);
                    transform: translateY(-2px);
                    box-shadow: @shadow-sm;
                }

                // 点击反馈
                &:active {
                    transform: translateY(0);
                }
            }
        }

        // 大客户折扣区域
        .vip-section {
            text-align: right;
            margin-bottom: @spacing-lg;

            .vip-btn {
                background-color: rgba(255, 215, 0, 0.1);
                border: 1px solid #ffd700;
                color: #ffd700;
                padding: @spacing-xs @spacing-md;
                border-radius: @radius-sm;
                cursor: pointer;
                font-size: 13px;
                transition: all 0.2s;

                &:hover {
                    background-color: rgba(255, 215, 0, 0.2);
                }
            }
        }

        // 确认充值按钮（调小尺寸）
        .confirm-section {
            display: flex;
            justify-content: center;

            .confirm-recharge-btn {
                width: 60%; // 从100%改为60%
                background-color: @accent;
                color: #fff;
                border: none;
                padding: @spacing-sm @spacing-md; // 内边距调小
                border-radius: @radius-md;
                cursor: pointer;
                font-size: 16px; // 字体调小
                font-weight: 600;
                transition: all 0.3s ease;
                box-shadow: 0 3px 0 rgba(22, 140, 255, 0.2); // 阴影调小

                &:hover {
                    background-color: darken(@accent, 5%);
                    transform: translateY(-2px);
                    box-shadow: 0 5px 0 rgba(22, 140, 255, 0.2);
                }

                &:active {
                    transform: translateY(0);
                    box-shadow: 0 1px 0 rgba(22, 140, 255, 0.2);
                }
            }
        }
    }

    // 注意事项（优化排版）
    .notice {
        background-color: @bg-secondary;
        border-radius: @radius-lg;
        padding: @spacing-lg;
        box-shadow: @shadow-sm;

        .notice-title {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: @spacing-md;
            color: @text-primary;
        }

        .notice-list {
            list-style-type: disc;
            padding-left: @spacing-md;
            font-size: 14px;
            color: @text-secondary;
            line-height: 1.6;

            li {
                margin-bottom: @spacing-xs;
            }
        }
    }

    // 响应式适配
    @media (max-width: 768px) {
        padding: @spacing-md;

        .header {
            flex-direction: column;
            align-items: flex-start;
            gap: @spacing-md;

            .balance {
                width: 100%;
                text-align: left;
            }
        }

        .amount-selector {
            grid-template-columns: repeat(2, 1fr);
        }

        .confirm-recharge-btn {
            width: 100% !important; // 移动端恢复100%宽度
        }
    }
}
</style>